import { render, staticRenderFns } from "./site-menu.vue?vue&type=template&id=3e515e77&"
import script from "./site-menu.vue?vue&type=script&lang=js&"
export * from "./site-menu.vue?vue&type=script&lang=js&"
import style0 from "./site-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports